export default "__VITE_ASSET__Cq365$zE__"